import { render, staticRenderFns } from "./integral-record.vue?vue&type=template&id=00f61f5a&scoped=true&"
import script from "./integral-record.vue?vue&type=script&lang=js&"
export * from "./integral-record.vue?vue&type=script&lang=js&"
import style0 from "./integral-record.vue?vue&type=style&index=0&id=00f61f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f61f5a",
  null
  
)

export default component.exports